import { getRequest, postRequest, deleteRequest } from './util/requestAlias';
import { buildURL } from './util/requestHandler';
/**
 * 🔐删除话题
 *
 * 删除话题。  只要没有错误异常，无论是否有话题被删除，该接口都会返回成功。
 */

export const del = params => deleteRequest(buildURL('/topics/{topic_id}', params));
/**
 * 🔑关注指定话题
 *
 * 关注指定话题。
 */

export const addFollow = params => postRequest(buildURL('/topics/{topic_id}/followers', params));
/**
 * 🔐发布话题
 *
 * 发布话题。
 */

export const create = params => {
  const formData = new FormData();
  formData.append('name', params.name);
  formData.append('description', params.description);
  formData.append('cover', params.cover);
  return postRequest(buildURL('/topics', params, ['include']), formData);
};
/**
 * 🔑取消关注指定话题
 *
 * 取消关注指定话题。
 */

export const deleteFollow = params => deleteRequest(buildURL('/topics/{topic_id}/followers', params));
/**
 * 🔐批量删除话题
 *
 * 批量删除话题。  只要没有错误异常，无论是否有话题被删除，该接口都会返回成功。
 */

export const deleteMultiple = params => deleteRequest(buildURL('/topics/{topic_ids}', params));
/**
 * 获取指定话题信息
 *
 * 获取指定话题信息。
 */

export const get = params => getRequest(buildURL('/topics/{topic_id}', params, ['include']));
/**
 * 获取指定话题下的文章
 *
 * 获取指定话题下的文章。
 */

export const getArticles = params => getRequest(buildURL('/topics/{topic_id}/articles', params, ['page', 'per_page', 'order', 'include']));
/**
 * 获取指定话题的关注者
 *
 * 不含已禁用的用户。
 */

export const getFollowers = params => getRequest(buildURL('/topics/{topic_id}/followers', params, ['page', 'per_page', 'include']));
/**
 * 获取全部话题
 *
 * 获取全部话题。
 */

export const getList = (params = {}) => getRequest(buildURL('/topics', params, ['page', 'per_page', 'include', 'order', 'topic_id', 'name', 'trashed']));
/**
 * 获取指定话题下的提问
 *
 * 获取指定话题下的提问。
 */

export const getQuestions = params => getRequest(buildURL('/topics/{topic_id}/questions', params, ['page', 'per_page', 'order', 'include']));
/**
 * 🔐把话题放入回收站
 *
 * 把话题放入回收站。
 */

export const trash = params => postRequest(buildURL('/topics/{topic_id}/trash', params, ['include']));
/**
 * 🔐批量把话题放入回收站
 *
 * 批量把话题放入回收站。
 */

export const trashMultiple = params => postRequest(buildURL('/topics/{topic_ids}/trash', params, ['include']));
/**
 * 🔐把话题移出回收站
 *
 * 把话题移出回收站。
 */

export const untrash = params => postRequest(buildURL('/topics/{topic_id}/untrash', params, ['include']));
/**
 * 🔐批量把话题移出回收站
 *
 * 批量把话题移出回收站。
 */

export const untrashMultiple = params => postRequest(buildURL('/topics/{topic_ids}/untrash', params, ['include']));
/**
 * 🔐更新话题信息
 *
 * 更新话题信息。  因为 formData 类型的数据只能通过 post 请求提交，所以这里不用 patch 请求
 */

export const update = params => {
  const formData = new FormData();
  formData.append('topic_id', params.topic_id.toString());
  params.name && formData.append('name', params.name);
  params.description && formData.append('description', params.description);
  params.cover && formData.append('cover', params.cover);
  return postRequest(buildURL('/topics/{topic_id}', params, ['include']), formData);
};